var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialIcon9(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31,
    height: 38,
    viewBox: "0 0 31 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2361",
    "data-name": "Rectangle 2361",
    width: 31,
    height: 38,
    transform: "translate(-0.355 0.039)",
    fill: "#101b2d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10394",
    "data-name": "Group 10394",
    transform: "translate(0.355 -0.039)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10393",
    "data-name": "Group 10393",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29371",
    "data-name": "Path 29371",
    d: "M29.945,3.157a1.917,1.917,0,0,0-1.607-.388A15.36,15.36,0,0,1,16.414.345a1.889,1.889,0,0,0-2.176,0A15.36,15.36,0,0,1,2.314,2.769,1.917,1.917,0,0,0,0,4.654V18.923A17.232,17.232,0,0,0,7.224,32.962l6.994,4.989a1.919,1.919,0,0,0,2.217,0l6.994-4.989a17.232,17.232,0,0,0,7.224-14.039V4.654a1.917,1.917,0,0,0-.708-1.5M26.821,18.923A13.4,13.4,0,0,1,21.2,29.84l-5.878,4.2-5.878-4.2A13.4,13.4,0,0,1,3.832,18.923V6.851A19.126,19.126,0,0,0,15.326,4.187,19.126,19.126,0,0,0,26.821,6.851Zm-8.542-4.391-5.157,5.18-1.706-1.727A1.923,1.923,0,0,0,8.7,20.708l3.063,3.065a1.94,1.94,0,0,0,1.359.567,1.976,1.976,0,0,0,1.367-.567l6.585-6.537a1.925,1.925,0,1,0-2.723-2.723Z",
    transform: "translate(0 0)",
    fill: "#101b2d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon9);
export default __webpack_public_path__ + "static/media/social_icon9.ad651a20206a32fbbb2fbed16467f995.svg";
export { ForwardRef as ReactComponent };